import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { FaSteam, FaYoutube } from "react-icons/fa6";

function ProjectCard(props) {
  return (
    <Card className="project-card-view">
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <Button variant="primary" href={props.trailerLink} target="_blank">
          <FaYoutube /> Trailer
        </Button>
        <Button
            variant="primary"
            href={props.steamLink}
            target="_blank"
            style={{ marginLeft: "20px" }}
          >
            <FaSteam /> Steam
        </Button>
      </Card.Body>
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
    </Card>
  );
}
export default ProjectCard;
